export const TEACHER_COURSE_STATUS = {   
    UNKNOWN: {
        id: 0,
        name: 'Unknown',
    },
    DRAFT: {
        id: 1,
        name: 'Draft',
    },    
    ACTIVE: {
        id: 2,
        name: 'Active',
    },
};

export const PRESENTATION_STATUS = {   
    UNKNOWN: {
        id: 0,
        name: 'Unknown',
    },
    DRAFT: {
        id: 1,
        name: 'Draft',
    },    
    ACTIVE: {
        id: 2,
        name: 'Active',
    },
};

export const GUIDANCE_STATUS = {   
    UNKNOWN: {
        id: 0,
        name: 'Unknown',
    },
    DRAFT: {
        id: 1,
        name: 'Draft',
    },    
    ACTIVE: {
        id: 2,
        name: 'Active',
    },
};
